import { Directive, Output, EventEmitter, HostListener, OnInit, Input } from '@angular/core';
import { LoadConfigService } from '../services/load-config.service';

@Directive({
    selector: '[appTriggerChoice]',
    standalone: false
})
export class TriggerChoiceDirective implements OnInit {
  // TODO:#code
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onKeypress: EventEmitter<string | number> = new EventEmitter<string | number>();
  @Input() appTriggerChoice = 'testMode';

  keyImportant: string;
  keyUnimportant: string;
  keyContinue: string;
  decisionKeys: string[];
  keysAgreement: string[];
  keysIAT: string[];

  @HostListener('document:keydown', ['$event.key']) onListenerTriggered(event: string): void {
    if (this.appTriggerChoice === 'agreement') {
      if (event === this.keysAgreement[0]) {
        this.onKeypress.emit(0);
      } else if (event === this.keysAgreement[1]) {
        this.onKeypress.emit(1);
      } else if (event === this.keysAgreement[2]) {
        this.onKeypress.emit(2);
      } else if (event === this.keysAgreement[3]) {
        this.onKeypress.emit(3);
      }
    } else if (this.appTriggerChoice === 'reading') {
      if (event === this.keyContinue) {
        this.onKeypress.emit('continue');
      }
    } else if (this.appTriggerChoice === 'forcedChoiceMode') {
      if (event === this.keyImportant) {
        this.onKeypress.emit('right');
      } else if (event === this.keyUnimportant) {
        this.onKeypress.emit('left');
      }
    } else if (this.appTriggerChoice === 'IAT') {
      if (event === this.keysIAT[0]) {
        // 0 indicates the left button was pressed
        this.onKeypress.emit(0);
      } else if (event === this.keysIAT[1]) {
        // 1 indicates the right button was pressed
        this.onKeypress.emit(1);
      }
    } else if (this.appTriggerChoice === 'priming') {
      if (event === this.keysIAT[0]) {
        // 0 indicates the left button was pressed
        this.onKeypress.emit(0);
      } else if (event === this.keysIAT[1]) {
        // 1 indicates the right button was pressed
        this.onKeypress.emit(1);
      }
    } else {
      if (event === this.keyImportant) {
        this.onKeypress.emit(1);
      } else if (event === this.keyUnimportant) {
        this.onKeypress.emit(0);
      }
    }
  }

  assignKeys() {
    // decisionKeys is of form [[important Key, label], [unimportant key, label]]
    this.keyImportant = this.decisionKeys[1] || 'n';
    this.keyUnimportant = this.decisionKeys[0] || 'x';
    this.keyContinue = ' ';
  }

  constructor(private loadConfigService: LoadConfigService) {}

  ngOnInit() {
    this.decisionKeys = this.loadConfigService.getDecisionKeys();
    this.keysAgreement = this.loadConfigService.getDecisionKeysAgreement();
    this.keysIAT = this.loadConfigService.getDecisionKeysIAT('IAT');
    this.assignKeys();
  }
}
